
class AATable extends HTMLElement {
    constructor() {
        super()
        this.onTabChange = this.onTabChange.bind(this)
    }

    connectedCallback() {
        this.tabsComponent = this.querySelector('ui-tabs')
        this.panels = [...this.querySelectorAll('[aa-tab]')]

        if (!this.tabsComponent) return

        this.setInitialState()
        this.tabsComponent.addEventListener('ui:tabchange', this.onTabChange)
    }

    disconnectedCallback() {
        if (this.tabsComponent) {
            this.tabsComponent.removeEventListener('ui:tabchange', this.onTabChange)
        }
    }

    setInitialState() {
        const activeTab = this.tabsComponent.querySelector('[role="tab"][aria-selected="true"]')
        const value = activeTab?.dataset.value

        this.updatePanels(value)
    }

    onTabChange(event) {
        const { value } = event.detail
        this.updatePanels(value)
    }

    updatePanels(value) {
        this.panels.forEach(panel => {
            const isActive = panel.getAttribute('aa-tab') === value

            panel.toggleAttribute('hidden', !isActive)
            panel.setAttribute('aria-hidden', String(!isActive))
        })
    }
}

customElements.define('aa-table', AATable)